import "./rightBar.scss";
import FollowList from "../latest_targets/Latest";
import CasesList from "../casesList/CasesList";

const RightBar = () => {

  return (
    <div className="rightBar">
      <div className="container">
        <div className="item">
         <CasesList/>
        </div>
        <div className="item">
          <FollowList />
        </div>
        
        <div className="item">
          <span>Online Users</span>
          <div className="user">
            <div className="userInfo">
              <img
                src="https://images.pexels.com/photos/4881619/pexels-photo-4881619.jpeg?auto=compress&cs=tinysrgb&w=1600"
                alt=""
              />
              <div className="online" />
              <span>User 1</span>
            </div>
          </div>
          <div className="user">
            <div className="userInfo">
              <img
                src="https://images.pexels.com/photos/4881619/pexels-photo-4881619.jpeg?auto=compress&cs=tinysrgb&w=1600"
                alt=""
              />
              <div className="online" />
              <span>User 2</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightBar;
